import * as types from '../../constants/actionsType'
import { CommaFormatted } from '../../../utils/commonFunction/CommanFunction'
const initialState = {
  paymentSummaryCard: [],
  subscriptionTypeDropdown: {},
  frequencyList: {},
  isLoadingSummaryCard: true,
  getPaymentInfo: [],
  isLoadingGetPayment: true,
  rateCardDeatails: {
    monthlyDollar: "",
    monthlyINR: "",
    noOfUser: 0,
    perUserDollar: "",
    perUserINR: "",
    subcriptionFrequency: 0,
    subcriptionId: 0,
    yearlyDollar: "",
    yearlyINR: ""
  },
  rateCardDeatailsloading: true,
  paymenyDetails: {
    plan: "",
    period: "",
    monthlyDollar: "",
    monthlyINR: "",
    noOfUser: 0,
    perUserDollar: "",
    perUserINR: "",
    subcriptionFrequency: 1,
    subcriptionId: 2,
    yearlyDollar: "",
    yearlyINR: "",
    rateCardsDeatailsloading: false
  },
  tempStoreConfirm: false,
  isLatestTransactionLoading:false,
  latestTransactionList:{head: [
    {
        label: 'Plan',
        align: 'left',
        isFilter: false,
        filterVal: null,
        index: 0
    },
    {
        label: 'Amount',
        align: 'left',
        isFilter: false,
        filterVal: null,
        index: 0
    },
    {
        label: 'Transaction Month/Year',
        align: 'left',
        isFilter: false,
        filterVal: null,
        index: 0
    },
    {
      label: 'Transaction Date',
      align: 'left',
      isFilter: false,
      filterVal: null,
      index: 0
  },
    {
        label: 'Status',
        align: 'left',
        isFilter: false,
        filterVal: null,
        index: 0
    },
    {
        label: 'Action',
        align: 'left',
        isFilter: false,
        filterVal: null,
        index: 0
    },
],
   body:[]
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SUCCESS_GET_SUBCRIPTION_DETAILS:
console.log(action.data.subscriptionDetailList)
      return {
        ...state,
        paymentSummaryCard: action.data.subscriptionDetailList,
        subscriptionTypeDropdown: action.data.subscriptionList,
        frequencyList: action.data.frequencyList,
        isLoadingSummaryCard: false
      }
    case types.FAIELD_GET_SUBCRIPTION_DETAILS:
      return {
        ...state,
        paymentSummaryCard: [],
        subscriptionTypeDropdown: [],
        frequencyList: [],
        isLoadingSummaryCard: true
      }
    case types.SUCCESS_GET_PAYMENT_INFO:

      return {
        ...state,
        getPaymentInfo: action.data,
        isLoadingGetPayment: false,
      }
    case types.FAILED_GET_PAYMENT_INFO:
      return {
        ...state,
        getPaymentInfo: [],
        isLoadingGetPayment: false,
      }

    case types.GET_RATE_CARD:

      return {
        ...state,
        rateCardDeatails: action.data,
        rateCardDeatailsloading: false,
        rateCardsDeatailsloading: false
      }
    case types.FAIELD_RATE_CARD:
      return {
        ...state,
        rateCardDeatails: {
          monthlyDollar: "",
          monthlyINR: "",
          noOfUser: 0,
          perUserDollar: "",
          perUserINR: "",
          subcriptionFrequency: 0,
          subcriptionId: 0,
          yearlyDollar: "",
          yearlyINR: ""
        },
        rateCardDeatailsloading: false,
        rateCardsDeatailsloading: true
      }

    case types.GET_PAYMENT_DETAILS: {
      return {
        ...state,
        paymenyDetails: action.data,
        tempStoreConfirm: true
      }
    }
    case types.LOADING_LATEST_TRANSACTIONS: {
      return {
        ...state,
        isLatestTransactionLoading: action.data
      }
    }
    case types.FAILED_LATEST_TRANSACTIONS: {
      return {
        ...state,
        latestTransactionList:{...state.latestTransactionList,body:[]}
      }
    }
    case types.GET_LATEST_TRANSACTIONS: {
      
      var data = action.data.map(i => {
        return [i.planName,"₹ "+ new Intl.NumberFormat('en-In').format(i.totalPrice), i.transactionMonthYear,i.transactionTime, {paymentStatus:i.status},  {
                                                                                                                    isView: true,
                                                                                                                    plan:i.planName,
                                                                                                                    amount:   "Rs "+ new Intl.NumberFormat('en-In').format(i.totalPrice),
                                                                                                                    subscriptionStart:i.subscriptionCreatedDate,
                                                                                                                    billedto:i.billedTo,
                                                                                                                    contanceEmail:i.invoiceEmail,
                                                                                                                    contactNumber:i.phoneNumber,
                                                                                                                    companyRegistrationNumber:i.companyRegistrationNumber,
                                                                                                                    address:i.address,
                                                                                                                    userCount:i.userCount,
                                                                                                                    status:i.status,
                                                                                                                    costPerUser:i.amountPerUser,
                                                                                                                    url:i.invoicePdfUrl,
                                                                                                                    paymentType:i.paymentType,
                                                                                                                    cardNumber:i.cardLast4Digit?.trim().length>=4?"XXXX XXXX XXXX "+i.cardLast4Digit:i.cardLast4Digit
                                                                                                                }]
      })
      return {
        ...state,
        latestTransactionList:{...state.latestTransactionList,body:data}
      }
    }
    case types.EMPTY_PAYMENT_REDUCER: {
      return {
        ...state,
        paymentSummaryCard: [],
        subscriptionTypeDropdown: {},
        frequencyList: {},
        isLoadingSummaryCard: false,
        getPaymentInfo: [],
        isLoadingGetPayment: false,
        rateCardDeatails: [],
        rateCardDeatailsloading: true,
        rateCardsDeatailsloading: true,
        tempStoreConfirm: false,
        paymenyDetails: {
          plan: "",
          period: "",
          monthlyDollar: "",
          monthlyINR: "",
          noOfUser: 0,
          perUserDollar: "",
          perUserINR: "",
          subcriptionFrequency: 1,
          subcriptionId: 2,
          yearlyDollar: "",
          yearlyINR: "",
        },
      }
    }

    default:
      return state
  }
}
export default reducer
